export { Heading7 } from "./Heading7";
